import { render, staticRenderFns } from "./PayBoxPurchaseInfo.vue?vue&type=template&id=2906e380&scoped=true&"
import script from "./PayBoxPurchaseInfo.vue?vue&type=script&lang=js&"
export * from "./PayBoxPurchaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./PayBoxPurchaseInfo.vue?vue&type=style&index=0&id=2906e380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2906e380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2906e380')) {
      api.createRecord('2906e380', component.options)
    } else {
      api.reload('2906e380', component.options)
    }
    module.hot.accept("./PayBoxPurchaseInfo.vue?vue&type=template&id=2906e380&scoped=true&", function () {
      api.rerender('2906e380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/PayBoxPurchaseInfo.vue"
export default component.exports